export const LOGO = require("./icons/logo.png");
export const LOGIN_BG = require("./images/login_bg.png");
export const LOGIN_IMG = require("./images/login-img.png");
